export enum DeviceNotificationType {
  ERROR = 0,
  WARNING = 1,
  INFO = 2,
}
